import React from 'react';
import { Box, Paper, Typography, TextField, alpha } from '@mui/material';
import DateRangeIcon from '@mui/icons-material/DateRange';

// Shared month-range filter Paper used at the top of every manager-dashboard
// statistics page — driving every chart below it.
const MonthRangeFilter = ({ fromMonth, toMonth, onFromMonthChange, onToMonthChange, color = '#2a78d6' }) => (
    <Paper
        elevation={0}
        sx={{ p: 2.5, borderRadius: 4, border: '1px solid rgba(11,11,11,0.08)', bgcolor: '#fff' }}
    >
        <Box display="flex" alignItems="center" gap={1} mb={1.5}>
            <DateRangeIcon sx={{ color: alpha(color, 0.8), fontSize: 20 }} />
            <Typography variant="subtitle2" fontWeight={600}>טווח תאריכים</Typography>
        </Box>
        <Box display="flex" gap={2} flexWrap="wrap" alignItems="center">
            <TextField
                label="מחודש"
                type="month"
                size="small"
                value={fromMonth}
                onChange={(e) => onFromMonthChange(e.target.value)}
                InputLabelProps={{ shrink: true }}
            />
            <TextField
                label="עד חודש"
                type="month"
                size="small"
                value={toMonth}
                onChange={(e) => onToMonthChange(e.target.value)}
                InputLabelProps={{ shrink: true }}
            />
            <Typography variant="caption" color="text.secondary">
                ברירת מחדל: 12 החודשים האחרונים כולל החודש הנוכחי · הטווח חל על כל הדשבורדים למטה
            </Typography>
        </Box>
    </Paper>
);

export default MonthRangeFilter;
